// import { useState } from "react";
// import { useZxing } from "react-zxing";

// export const BarcodeScanner = () => {
//   const [result, setResult] = useState("");
//   const { ref } = useZxing({
//     onDecodeResult(result) {
//       setResult(result.getText());
//     },
//   });

//   return (
//     <>
//       <video ref={ref} />
//       <p>
//         <span>Last result:</span>
//         <span>{result}</span>
//       </p>
//     </>
//   );
// };

// import { useState } from "react";
// import { useZxing } from "react-zxing";

// export const BarcodeScanner = () => {
//   const [result, setResult] = useState("");
//   const [scanned, setScanned] = useState(false); // Track if the scan has been successful
//   const { ref } = useZxing({
//     onDecodeResult(result) {
//       if (!scanned) { // Check if a scan has already been made
//         setResult(result.getText());
//         setScanned(true); // Set the scanned flag to true
//       }
//     },
//   });

//   return (
//     <>
//       {!scanned && <video ref={ref} />} {/* Only show video if not scanned */}
//       <p>
//         <span>Last result:</span>
//         <span>{result}</span>
//       </p>
//     </>
//   );
// };


import { Box, Container } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useZxing } from "react-zxing";


export const BarcodeScanner = ({ handleDecode, handleError, handleStop }) => {
    const [result, setResult] = useState("");
    const [scanned, setScanned] = useState(false); // Track if the scan has been successful
    const [facingMode, setFacingMode] = useState("user");

    // Determine camera type based on device type
    useEffect(() => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        setFacingMode(isMobile ? "environment" : "user"); // Use back camera for mobile
    }, []);

    const { ref } = useZxing({
        onDecodeResult(result) {
            if (!scanned) { // Check if a scan has already been made
                const decodedText = result.getText();
                setResult(decodedText);
                setScanned(true); // Set the scanned flag to true
                handleDecode(decodedText); // Pass the result to App.js
            }
        },
        onError(error) {
            handleError(error); // Pass errors to App.js if needed
        },
        video: {
            facingMode, // Set the facingMode based on device type
        },
    });

    // // Button to stop the scan
    // const handleStopScan = () => {
    //     setScanned(true);
    // };

    return (
        <Container>
            <Box>
                {!scanned && <video ref={ref} />}
            </Box>
        </Container>
    );
};
